import { http } from '../../../api'

const faq = {
  namespaced: true,
  state: {
    newsList: [],
    news: null
  },
  actions: {
    getAllNews: ({ commit }) => {
      return http.get('/news').then(res => {
        commit('setNewsList', res.data.data)
      })
    },
    getNews: ({ commit }, params) => {
      return http.get('/news/' + params.id).then(res => {
        commit('setNews', res.data.data)
      })
    },
    deleteNews: ({ commit }, params) => {
      return http.delete('/news/' + params.id).then(res => {
        if (res.data.deleteType === 'forceDelete') {
          commit('setNewsListAfterDelete', params.id)
        } else {
          commit('setUpdateNewsStatus', { id: params.id, status: 'inactive' })
        }
      })
    },
    restoreNews: ({ commit }, params) => {
      return http.get('/news/' + params.id + '/restore').then(res => {
        commit('setUpdateNewsStatus', { id: params.id, status: 'active' })
      })
    },
    getWithTrashedNews: ({ commit }, params) => {
      let url = '/news'
      if (params) {
        const q = new URLSearchParams(params)
        url = url + '?' + q.toString()
      }
      return http.get(url).then(res => {
        commit('setNewsList', res.data.data)
        return res.data
      })
    },
    updateNews: ({ commit }, params) => {
      return http.post('/news/' + params.id, params.data).then(res => {
      })
    },
    createNews: ({ commit }, params) => {
      return http.post('/news', params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        return res.data
      })
    }
  },
  mutations: {
    setNewsList (state, data) {
      state.newsList = data
    },
    setNews (state, data) {
      state.news = data
    },
    setNewsListAfterDelete (state, id) {
      state.newsList = state.newsList.filter(item => item.id !== id)
    },
    setUpdateNewsStatus (state, data) {
      state.newsList = state.newsList.map(item => {
        if (item.id === data.id) {
          item.status = data.status
        }
        return item
      })
    }
  },
  getters: {
    newsList: state => state.newsList
  }
}

export default faq
